<template>
  <div style="display: flex">
    <!-- 温度 -->
    <temperature
      v-model="stepItem.temperature"
      :dev-mode="devMode"
      :permissions="permissions"
      @change="handleParamChange" />

    <!-- 非烤箱模式下的字段 -->
    <template v-if="type !== 'OVEN'">
      <!-- 旋转方向 -->
      <rotate-direction
        v-model="stepItem.rotateDirection"
        :dev-mode="devMode"
        :permissions="permissions"
        :is-air="isAir"
        :rotate-direction="rotateDirection"
        @change="handleChangeRotateDirection" />

      <!-- 旋转速度 -->
      <rotate-speed
        v-model="stepItem.rotateSpeed"
        :dev-mode="devMode"
        :permissions="permissions"
        :is-air="isAir"
        :get-motor-gear-count="getMotorGearCountFn"
        :rotate-direction="stepItem.rotateDirection"
        @change="handleParamChange" />

      <!-- 喷水档位 -->
      <water-gear
        v-model="stepItem.waterGear"
        :dev-mode="devMode"
        :permissions="permissions"
        @change="handleParamChange" />
    </template>

    <!-- 时间-分 -->
    <minute
      v-model="stepItem.minute"
      :dev-mode="devMode"
      :permissions="permissions"
      :minute-time="minuteTime"
      @change="handleParamChange" />

    <!-- 时间-秒 -->
    <second
      v-model="stepItem.second"
      :dev-mode="devMode"
      :permissions="permissions"
      @change="handleParamChange" />
  </div>
</template>

<script>
import potParamsMixin from "./mixins/potParamsMixin";
// 参数字段组件
import Temperature from "./params/Temperature";
import RotateDirection from "./params/RotateDirection";
import RotateSpeed from "./params/RotateSpeed";
import WaterGear from "./params/WaterGear";
import Minute from "./params/Minute";
import Second from "./params/Second";

export default {
  name: 'FirstPotParams',
  mixins: [potParamsMixin],
  components: {
    Temperature,
    RotateDirection,
    RotateSpeed,
    WaterGear,
    Minute,
    Second
  },
  props: {
    // 步骤数据对象
    stepItem: {
      type: Object,
      required: true
    },
    // 工作模式配置
    devMode: {
      type: Object,
      default: null
    },
    // 食谱类型
    type: {
      type: String,
      required: true
    },
    // 旋转方向选项
    rotateDirection: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    // 计算电机档位数的函数（使用上锅的 rotateDirection）
    getMotorGearCountFn() {
      return this.getMotorGearCount(this.stepItem.rotateDirection);
    }
  },
  methods: {
    // 参数校验（上锅专用，使用上锅的时间字段）
    handleParamChange() {
      let devMode = this.devMode;

      // 如果 devMode 不存在，直接返回
      if (!devMode) return;

      // 使用上锅的时间字段
      let minute = this.stepItem.minute || 0;
      let second = this.stepItem.second || 0;
      let time = ((minute * 60) + second);

      if (time > devMode.maxTime) {
        this.$set(this.stepItem, 'minute', parseInt(devMode.maxTime / 60));
        this.$set(this.stepItem, 'second', parseInt(devMode.maxTime % 60));
      }
      // 组件内部已处理所有逻辑，不需要通知外部
    },

    // 切换旋转方向（上锅专用，需要重置旋转速度）
    handleChangeRotateDirection() {
      // 改变旋转方向时，重置旋转速度
      this.$set(this.stepItem, 'rotateSpeed', null);
    }
  }
};
</script>

